import React from 'react';
import { toSafeColor } from '../../utils/to-safe-color';
import { DefaultOverride } from '../override';
import { ColumnItem } from '../column-item';
export function Text(props) {
    const { align = 'left', children, color = '#000000', containerBackgroundColor, cssClass, fontFamily = 'Ubuntu, Helvetica, Arial, sans-serif', fontSize = '13px', fontStyle, fontWeight, lineHeight = '1', padding = '10px 25px', paddingBottom, paddingLeft, paddingRight, paddingTop, textDecoration, textTransform, override, overrideProps, } = props;
    const OverrideWith = override || DefaultOverride;
    return (React.createElement(ColumnItem, { align: align, padding: padding, cssClass: cssClass, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, paddingTop: paddingTop, containerBackgroundColor: toSafeColor(containerBackgroundColor) },
        React.createElement(OverrideWith, { ...overrideProps },
            React.createElement("div", { style: {
                    fontFamily,
                    fontSize,
                    fontStyle,
                    fontWeight,
                    lineHeight,
                    textAlign: align,
                    textDecoration,
                    textTransform,
                    color: toSafeColor(color),
                    whiteSpace: 'pre-wrap',
                } }, children))));
}
//# sourceMappingURL=text.js.map